export default __webpack_public_path__ + "static/media/rfq.e84af740.svg";